import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";

const CargosMasivosDialog = ({
  visible,
  setVisible,
  conceptos,
  alumnos,
  onGuardar
}) => {
  const [form, setForm] = useState({
    id_concepto: null,
    periodo: "",
    fecha_vencimiento: null,
    monto: null,
    grados: [],
    grupos: [],
    todos: false
  });

  const [previewCount, setPreviewCount] = useState(0);

  // 🔹 opciones dinámicas
  const gradosOptions = [...new Set(alumnos.map(a => a.Grado))]
    .map(g => ({ label: g, value: g }));

  const gruposOptions = [...new Set(alumnos.map(a => a.Grupo))]
    .map(g => ({ label: g, value: g }));

  // 🔹 calcular preview
  useEffect(() => {
    let filtered = alumnos;

    if (!form.todos) {
      if (form.grados.length) {
        filtered = filtered.filter(a => form.grados.includes(a.Grado));
      }

      if (form.grupos.length) {
        filtered = filtered.filter(a => form.grupos.includes(a.Grupo));
      }
    }

    setPreviewCount(filtered.length);
  }, [form, alumnos]);

  const guardar = () => {
    if (!form.id_concepto || !form.periodo) {
      alert("Faltan campos obligatorios");
      return;
    }

    if (!form.todos && previewCount === 0) {
      alert("No hay alumnos seleccionados");
      return;
    }

    onGuardar(form);
    setVisible(false);
    limpiar();
  };

  const limpiar = () => {
    setForm({
      id_concepto: null,
      periodo: "",
      fecha_vencimiento: null,
      monto: null,
      grados: [],
      grupos: [],
      todos: false
    });
  };

  return (
    <Dialog
      header="Cargos Masivos"
      visible={visible}
      style={{ width: "500px" }}
      onHide={() => setVisible(false)}
      modal
    >
      <div className="p-fluid grid">

        {/* CONCEPTO */}
        <div className="field col-12">
          <label>Concepto</label>
          <Dropdown
            value={form.id_concepto}
            options={conceptos}
            optionLabel="nombre"
            optionValue="id"
            placeholder="Selecciona concepto"
            onChange={(e) =>
              setForm({ ...form, id_concepto: e.value })
            }
          />
        </div>

        {/* PERIODO */}
        <div className="field col-6">
          <label>Periodo</label>
          <InputText
            value={form.periodo}
            onChange={(e) =>
              setForm({ ...form, periodo: e.target.value })
            }
          />
        </div>

        {/* FECHA */}
        <div className="field col-6">
          <label>Fecha vencimiento</label>
          <Calendar
            value={form.fecha_vencimiento}
            onChange={(e) =>
              setForm({ ...form, fecha_vencimiento: e.value })
            }
            showIcon
          />
        </div>

        {/* MONTO */}
        <div className="field col-12">
          <label>Monto</label>
          <InputText
            value={form.monto || ""}
            onChange={(e) =>
              setForm({ ...form, monto: Number(e.target.value) })
            }
          />
        </div>

        {/* TODOS */}
        <div className="field col-12">
          <Checkbox
            checked={form.todos}
            onChange={(e) =>
              setForm({ ...form, todos: e.checked })
            }
          />
          <label className="ml-2">Aplicar a todos los alumnos</label>
        </div>

        {/* FILTROS */}
        {!form.todos && (
          <>
            <div className="field col-6">
              <label>Grado</label>
              <MultiSelect
                value={form.grados}
                options={gradosOptions}
                onChange={(e) =>
                  setForm({ ...form, grados: e.value })
                }
                placeholder="Selecciona"
              />
            </div>

            <div className="field col-6">
              <label>Grupo</label>
              <MultiSelect
                value={form.grupos}
                options={gruposOptions}
                onChange={(e) =>
                  setForm({ ...form, grupos: e.value })
                }
                placeholder="Selecciona"
              />
            </div>
          </>
        )}

        {/* PREVIEW */}
        <div className="col-12">
          <div className="p-3 border-1 border-round surface-100 text-center">
            <b>{previewCount}</b> alumnos serán afectados
          </div>
        </div>

      </div>

      {/* FOOTER */}
      <div className="flex justify-content-end gap-2 mt-3">
        <Button
          label="Cancelar"
          className="p-button-text"
          onClick={() => setVisible(false)}
        />
        <Button
          label="Aplicar Cargos"
          icon="pi pi-check"
          onClick={guardar}
        />
      </div>
    </Dialog>
  );
};

export default CargosMasivosDialog;